import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import img1 from "../Assets/IMG/socialpanga-about-gallery2.jpg";
import img2 from "../Assets/IMG/socialpanga-about-gallery5.jpg";
import img3 from "../Assets/IMG/socialpanga-about-gallery3.jpg";
import img4 from "../Assets/IMG/socialpanga-about-gallery6.jpg";
import img5 from "../Assets/IMG/socialpanga-about-gallery1.jpg";
import img6 from "../Assets/IMG/socialpanga-about-gallery4.jpg";

import AboutCreativeSection from "../Pages/AboutCreativeSection";

import caroBg from "../Assets/IMG/BG_02.gif";

const images = [
  { src: img1, width: 572 },
  { src: img2, width: 302 },
  { src: img3, width: 572 },
  { src: img4, width: 302 },
  { src: img5, width: 572 },
  { src: img6, width: 302 },
];

const ImageCarousel = () => {
  const [isMobile, setIsMobile] = useState(false);
  

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const desktopSettings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: false,
    centerMode: true,
    variableWidth: true,
  };

  const mobileSettings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: false,
    centerMode: false,
    variableWidth: false,
  };

  return (
    <>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "8% auto", }}>
        <Slider {...(isMobile ? mobileSettings : desktopSettings)}>
          {images.map((img, index) => (
            <div
              key={index}
              style={{
                width: isMobile ? "100%" : img.width,
                padding: isMobile ? "0 5px" : "0",
                
              }}
            >
              <img
                src={img.src}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "98.5%",
                  height: isMobile ? "220px" : "450px",
                  objectFit: "cover",
                  borderRadius: "2px",
                  
                }}
              />
            </div>
          ))}
        </Slider>
      </div>

      <AboutCreativeSection />
    </>
  );
};

export default ImageCarousel;
